import { api } from '../../../api/axios'
import type { Etapa, EtapaFilters } from '../types'

export interface ListResponse<T> {
  data: T[]
  meta: { total: number; page: number; limit: number; totalPages: number }
}

export const etapasService = {
  list: (filters: EtapaFilters = {}) =>
    api.get<ListResponse<Etapa>>('/etapas', { params: filters }).then(r => r.data),

  getById: (id: number) =>
    api.get<{ data: Etapa }>(`/etapas/${id}`).then(r => r.data.data),

  create: (data: Omit<Etapa, 'idetapa' | 'modalidade_nome' | 'campeonato_descricao'>) =>
    api.post<{ data: Etapa }>('/etapas', data).then(r => r.data.data),

  update: (id: number, data: Partial<Omit<Etapa, 'idetapa' | 'modalidade_nome' | 'campeonato_descricao'>>) =>
    api.put<{ data: Etapa }>(`/etapas/${id}`, data).then(r => r.data.data),

  delete: (id: number) =>
    api.delete(`/etapas/${id}`),
}
